import { Paper, useTheme } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { mainishStyles } from '../../styling';
import PageHeader from '../Common/PageHeader';
import FormPengisian from './PageOne';
import StepTwo from './PageTwo';

export default function Home() {
  const mainishclasses = mainishStyles();
  const theme = useTheme();

  sessionStorage.clear();

  return (
    <>
      <PageHeader
        icon={
          <CreateIcon
            color={theme.palette.type === 'dark' ? 'secondary' : 'primary'}
          />
        }
        title="Form Pelayanan"
        subTitle="Isi form di bawah ini untuk mendapatkan layanan kemahasiswaan."
      />
      <Paper className={mainishclasses.pageContent}>
        <Router basename="/layanan">
          <Switch>
            <Route exact path="/" component={FormPengisian} />
            <Route path="/2" component={StepTwo} />
          </Switch>
        </Router>
      </Paper>
    </>
  );
}
